module.exports = __webpack_public_path__ + "basicImage.webp?7530384fa25469fb138f133ce1b9313b";